var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"15","cy":"15","r":"15","fill":"#fff"}}),_c('path',{attrs:{"d":"M10 15.5l4 4 7.5-7.5","stroke":"#5A80FB","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }